import { ref as f, computed as e, watch as V } from "vue";
import { getPriceFormatted as g, defaultPriceOptions as y, getEnergyEfficiencyProduct as K } from "@i22/rocket";
function z(x, h, O = !1) {
  const i = f(0), o = f(null), s = f(!1), t = e(() => x?.variants?.COLOR?.items), v = e(() => {
    if (t.value)
      return t.value[o.value || i.value || 0] || void 0;
  }), d = e(() => t.value ? (i.value + 1) % t.value.length : 0), m = e(() => t.value?.[d.value]), u = e(() => v.value?.offer), r = e(() => {
    if (u.value?.product?.articleNumber)
      return h?.[u.value.product.articleNumber] || void 0;
  }), p = e(() => r.value?.image ? r.value.image : r.value?.key && t.value?.[r.value.key] ? t.value[r.value.key].teaserImage : v.value?.teaserImage), b = e(() => r.value?.hoverImage ? r.value.hoverImage : r.value?.hoverKey && t.value?.[r.value.hoverKey] ? t.value[r.value.hoverKey].teaserImage : m.value?.teaserImage || p.value), A = e(
    () => g(
      u.value?.prices || [],
      "DEFAULT",
      "ONETIME",
      y
    ) || void 0
  ), E = e(
    () => g(u.value?.prices || [], "WAS", "ONETIME", y) || void 0
  ), H = e(() => {
    if (u.value?.product)
      return K(u.value.product);
  });
  V(
    t,
    (a) => {
      if (!a) {
        i.value = 0;
        return;
      }
      let n = a.findIndex((I) => I.active) || 0;
      if (!O) return;
      const l = a[n]?.offer?.product;
      l && "availability" in l && (l.availability?.stock || 0) > 0 && (n = a.findIndex((c) => c.offer?.product && "availability" in c.offer.product ? (c.offer?.product?.availability?.stock || 0) > 0 : !1) || 0), i.value = Math.max(0, n);
    },
    { immediate: !0, deep: !0 }
  );
  const k = () => {
    o.value = null;
  }, N = (a) => {
    o.value = a;
  }, P = (a) => {
    i.value = a || 0;
  }, T = (a) => {
    s.value = a;
  };
  return {
    offerUrl: e(() => v.value?.path),
    activeIndex: i,
    hoverIndex: o,
    isHovered: s,
    colorAlternatives: t,
    activeOfferVariant: v,
    nextOfferIndex: d,
    nextOfferVariant: m,
    manualImage: r,
    productImage: p,
    productImageHover: b,
    activeOffer: u,
    priceHumanized: A,
    priceWasHumanized: E,
    energyLabel: H,
    resetHoverItem: k,
    setHoverItem: N,
    setActiveItemIndex: P,
    setHoverState: T
  };
}
export {
  z as default
};
